import React from 'react';
import { useNavigate } from 'react-router-dom';

const IdeeTesterPromoCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate('/idee-tester')}
      className="mb-10 cursor-pointer group rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-0.5"
      style={{
        background: 'linear-gradient(135deg, #e8f1ff 0%, #d4e4ff 100%)',
        border: '1px solid #c5d8f5',
      }}
    >
      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 p-5 sm:p-6">
        <div
          className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-3xl"
          style={{ background: 'rgba(255, 255, 255, 0.7)' }}
        >
          💡
        </div>

        <div className="flex-1 text-center sm:text-left">
          <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-1">
            Twijfel je of je idee aanslaat?
          </h3>
          <p className="text-sm sm:text-base text-gray-700">
            Wij bouwen een MVP website, draaien Google Ads en meten of mensen écht interesse hebben. Vanaf €295.
          </p>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate('/idee-tester');
          }}
          className="flex-shrink-0 text-white px-6 py-3 rounded-lg font-semibold transition transform group-hover:scale-105 shadow-md whitespace-nowrap"
          style={{
            background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
          }}
        >
          Test je idee →
        </button>
      </div>
    </div>
  );
};

export default IdeeTesterPromoCard;
